// @file Handles draft_id URL query param shortcut for Surface
import { getAndClearSearchParam } from '@@/bits/location'
import { usePostComposerModalStore } from '@@/pinia/post_composer_modal_store'
import { useSurfaceDraftsStore } from '@@/pinia/surface_drafts'
import { storeToRefs } from 'pinia'
import { nextTick, watch } from 'vue'

function useSurfaceUrlDraftShortcut(): void {
  const rawDraftId = getAndClearSearchParam('draft_id')
  if (rawDraftId == null) return

  const draftId = parseInt(rawDraftId, 10)
  if (isNaN(draftId)) return

  const surfaceDraftsStore = useSurfaceDraftsStore()
  const { hasFetchedInitialPostDrafts, draftById } = storeToRefs(surfaceDraftsStore)

  async function openDraft(): Promise<void> {
    const draft = draftById.value[draftId]
    if (draft == null) return
    surfaceDraftsStore.startEditingDraft(draft.cid)
    // Wait for Vue to flush updates so the composer modal list registers the
    // draft before we imperatively dock it.
    await nextTick()
    const postComposerModalStore = usePostComposerModalStore()
    if (postComposerModalStore.isDockableModalListRegistered) {
      postComposerModalStore.expandComposerModal(draft.cid)
    }
  }

  if (hasFetchedInitialPostDrafts.value) {
    void openDraft()
    return
  }

  const unwatch = watch(hasFetchedInitialPostDrafts, async (hasFetched) => {
    if (!hasFetched) return
    unwatch()
    await openDraft()
  })
}

export { useSurfaceUrlDraftShortcut }
